import { render, staticRenderFns } from "./myOrders.vue?vue&type=template&id=d61145cc&scoped=true&lang=true&"
import script from "./myOrders.vue?vue&type=script&lang=js&"
export * from "./myOrders.vue?vue&type=script&lang=js&"
import style0 from "./myOrders.vue?vue&type=style&index=0&id=d61145cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61145cc",
  null
  
)

export default component.exports